/**
 * External dependencies
 */
import {createReduxStore, register} from '@wordpress/data';
import * as selectors from './selectors';
import * as actions from './actions';
import reducer from './reducers';
import apiFetch from '@wordpress/api-fetch';
import {YWCAS_HAS_AUTOCOMPLETE, YWCAS_LANG, YWCAS_MIN_CHARS} from "../../config";
export const YWCAS_RESULTS_VIEW_STORE_KEY = 'yith/store/ywcas-search-view';
export const config = {
    reducer,
    selectors,
    actions,
    controls: {
        FETCH_FROM_API(action) {
            return apiFetch({path: action.path});
        },
    },
    resolvers: {
        * getSearchedResults(query, category = 0, showCategories = false, maxResults = 5, isEditor = false) {
            if (!isEditor && (typeof query === 'undefined' || '' === query || !YWCAS_HAS_AUTOCOMPLETE || query.length < YWCAS_MIN_CHARS)) {
                return actions.setSearchedResults({
                    totalResults: 0,
                    query: '',
                    results: [],
                    relatedContent: {},
                });
            }
            let path = '/ywcas/v1/search?query=' + query + '&lang='+YWCAS_LANG+'&category=' + category + '&showCategories=' + showCategories + '&maxResults=' + maxResults;
            path += isEditor ? '&test=1' : '';
            const results = yield  actions.fetchFromAPI(path);

            return actions.setSearchedResults(results);

        },
        * getCategories(type) {
            const path = '/ywcas/v1/categories?type=' + type+'&lang='+YWCAS_LANG;
            const categories = yield actions.fetchFromAPI(path);
            return actions.setCategories(categories);
        },

    },
    __experimentalUseThunks: true,
};

const store = createReduxStore(YWCAS_RESULTS_VIEW_STORE_KEY, config);
register(store);